import script from "./EmpresasAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpresasAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./EmpresasAdministrar.vue?vue&type=style&index=0&id=4b4cee54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4cee54"]])

export default __exports__